import { Box, Typography, TextField, Button, Select, MenuItem, Autocomplete, styled, FormControl, FormControlLabel, RadioGroup, Radio, FormGroup, Checkbox, InputAdornment, IconButton } from '@mui/material'
import React, { useEffect, useState } from 'react'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useLocation, useNavigate } from 'react-router-dom';
import * as api from '../services/api'
import styles from './healthAss.module.css'
import one from '../../assets/icons/assessment/one-servey.svg'
import two from '../../assets/icons/assessment/two-servey.svg'
import three from '../../assets/icons/assessment/three-servey.svg'
import { useDispatch } from 'react-redux';
import { user_data } from '../../store/authSlice';
import { menuActive } from '../../store/menuSlice';
import dayjs from 'dayjs'
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import Loader from '../../components/Loader';
import CircleIcon from '@mui/icons-material/Circle';
import { withStyles } from '@mui/styles';
import ModalCalendar from '../../components/modal/ModalCalendar';
import moment from 'moment';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import back from '../../assets/icons/back.svg';
import CustomizedModal from '../../components/modal/CustomizedModal';

export default function HealthBehaviorSurvey() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const [loading, setLoading] = useState(false)
  const [showCancelModal, setShowCancelModal] = useState(false);

  const [gender, setGender] = useState([])
  const [titlename, setTitlename] = useState([])
  const [department, setDepartment] = useState([])

  const [data, setData] = useState({
    title_name: "", //ยศ
    department_name: "", //สังกัด
    department_code: "",
    fname: "", //ชื่อ
    lname: "", //นามสกุล
    sex: "", //เพศ
    age: "", //อายุ
    pid: "", //เลขบัตรประชาชน
    birthday: "",
    weight: "",
    height: "",
    waist: "",
    phone: "",
    consent: "Y"
  });
  const option = [1, 2, 3]
  const option1 = [3, 2, 1]

  const [disease, setDisease] = useState('ไม่มีโรคประจำตัว')
  const [diseaseList, setDiseaseList] = useState([])
  const diseaseAll = [
    'โรคเบาหวาน',
    'โรคความดันโลหิตสูง',
    'โรคหัวใจ',
    'โรคปอดอุดกั้นเรื้อรัง',
    'โรคไตวายเรื้อรัง',
    'โรคเกี่ยวกับต่อมไร้ท่อ',
    'โรคตับอักเสบ',
    'โรคข้อเข่าเสื่อม',
    'โรคมะเร็ง',
    'ไขมันในเลือดสูง',
    'จิตเวช',
    'โรคหลอดเลือดสมอง',
    // 'อื่น ๆ โปรดระบุ'
  ]
  const [other, setOther] = useState(false)
  const [remark, setRemark] = useState('')

  const [quitSmoking, setQuitSmoking] = useState(false)
  const [smoke, setSmoke] = useState({
    smoke: '',
    smoking: '',
    need: '',
  })
  const [eating, setEating] = useState({
    eating1: '',
    eating2: '',
    eating3: '',
    eating4: '',
    eating5: '',
    eating6: '',
    eating7: '',
    eating8: '',
    eating9: '',
    eating10: '',
    eating11: '',
    eating12: '',
    eating13: '',
    eating14: '',
    eating15: '',
  })
  const [alcohol, setAlcohol] = useState(null)
  const [exercise, setExercise] = useState(null)
  const [lollop, setLollop] = useState(null)
  const [vegetable, setVegetable] = useState(null)

  if (!location.state) {
    location.state = { button: "1" };
  }

  const [openCalendar, setOpenCalendar] = useState(false)
  const [disabledDay, setDisabledDay] = useState([])

  const [isValidweight, setIsValidweight] = useState(false);
  const [isValidheight, setIsValidheight] = useState(false);
  const [isValidwaist, setIsValidwaist] = useState(false);
  const [isValidphone, setIsValidphone] = useState(false);
  const [isValidpid, setIsValidpid] = useState(false);

  const handleCloseCancelModal = () => setShowCancelModal(false);

  useEffect(() => {
    dispatch(menuActive('แบบประเมินสุขภาพ'))
    getProfile()

    findGender()
    findTitleName()
    findDepartmentFixToken()
  }, [])

  const handleButton = (number) => {
    navigate('/healthBehaviorSurvey', { state: { button: number } });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const confirmCancelChanges = () => {
    setShowCancelModal(false);
    navigate('/assessment'); 
  };

  const handleChangePID = (e) => {
    setData({ ...data, 'pid': e.target.value });
    const regex = /^\d{13}$/;
    setIsValidpid(regex.test(e.target.value));
  }

  const handleChangeAge = (e) => {
    const maxLength = 2;
    const numericRegex = /^[0-9]*$/;
    if (e.target.value.length <= maxLength && numericRegex.test(e.target.value)) {
      setData({ ...data, 'age': e.target.value });
    }
  }

  const handleChangePhone = (e) => {
    setData({ ...data, 'phone': e.target.value });
    const regex = /^\d{10}$/;
    setIsValidphone(regex.test(e.target.value));
  }

  const findGender = async () => {
    setLoading(true)
    let res = await api.gender()
    setLoading(false)
    if (res) {
      if (res['data']['code'] == 200) {
        setGender(res['data']['data'])
      } else {
        //alert(res['data']['message'])
      }
    } else {
      alert('ไม่ตอบสนอง')
    }
  }

  const findTitleName = async () => {
    setLoading(true)
    let res = await api.titleName()
    setLoading(false)
    if (res) {
      if (res['data']['code'] == 200) {
        let option = []
        for (let i = 0; i < res['data']['data'].length; i++) {
          if (res['data']['data'][i]) {
            option.push({
              key: res['data']['data'][i]['value'],
              label: res['data']['data'][i]['name']
            })
          }
          const unique = [...new Map(option.map((m) => [m.key, m])).values()] //กรองชื่อซ้ำ
          setTitlename(unique)
        }
      } else {
        //alert(res['data']['message'])
      }
    } else {
      alert('ไม่ตอบสนอง')
    }
  }

  const findDepartmentFixToken = async () => {
    setLoading(true)
    let res = await api.findDepartmentFixToken()
    setLoading(false)
    if (res) {
      if (res['data']['code'] == 200) {
        let option = []
        for (let i = 0; i < res['data']['data'].length; i++) {
          if (res['data']['data'][i]) {
            option.push({
              key: res['data']['data'][i]['department_code'],
              label: res['data']['data'][i]['department_name']
            })
          }
          const unique = [...new Map(option.map((m) => [m.key, m])).values()] //กรองชื่อซ้ำ
          setDepartment(unique)
        }
      } else {
        //alert(res['data']['message'])
      }
    } else {
      alert('ไม่ตอบสนอง')
    }
  }

  const getProfile = async () => {
    setLoading(true)
    let res = await api.profile()
    setLoading(false)
    if (res) {
      if (res['data']['code'] === 200) {
        // console.log(res['data']['data'])
        // dispatch(user_data(res['data']['data']))

        let detail = res['data']['data']
        setData({
          ...data,
          'title_name': detail['titlename'],
          'department_name': detail['department']?.['department_name'],
          'department_code': detail['department']?.['department_code'],
          'fname': detail['firstname'],
          'lname': detail['lastname'],
          'sex': detail['gender'],
          'pid': detail['card_id'],
          'birthday': detail?.['dob'],
          'phone': detail['phone']
        });

        const regex = /^\d{13}$/;
        setIsValidpid(regex.test(detail['card_id']));

        const regexPhone = /^\d{10}$/;
        setIsValidphone(regexPhone.test(detail['phone']));
        // console.log(detail)
      } else {
        //alert(res['data']['message'])
      }
    } else {
      alert('ไม่ตอบสนอง')
    }
  }

  const formatDate = (date) => {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }

  const saveHealthBehavior = () => {
    let inform = {
      "title_name": data['title_name'],
      "department_code": data['department_code'],
      "firstname": data['fname'],
      "lastname": data['lname'],
      "gender": data['sex'],
      "age": data['age'],
      "date_of_birth": formatDate(data['birthday']),
      "pid": data['pid'],
      "phone": data['phone'],
      "weight": data['weight'],
      "height": data['height'],
      "waist": data['waist'],
      "consent": data['consent'],
      "evaluate_q2_1": {
        "question": "ท่านมีโรคประจำตัวที่ต้องพบแพทย์และรับประทานยาอย่างต่อเนื่องหรือไม่ (เลือกได้หลายตัวเลือก)",
        "answer": disease,
        "answer2": diseaseList,
        "remark": remark
      },
      "evaluate_q3_1": {
        "question": "1) ท่านสูบบุหรี่หรือบุหรี่ไฟฟ้าหรือไม่",
        "answer": smoke['smoke'],
        "answer2": smoke['smoking']
      },
      "evaluate_q3_1_1": {
        "question": "1.1) ท่านต้องการเลิกหรือไม่",
        "answer": smoke['need']
      },
      "evaluate_q3_2": {
        "question": "2) ท่านดื่มสุรา หรือเครื่องดื่มที่มีแอลกอฮอร์หรือไม่",
        "answer": alcohol
      },
      "evaluate_q3_3": {
        "question": "3) ท่านมีการขยับร่างกายจนเหนื่อยกว่าปกติ (รวมการทำงาน การเดินทาง การประกอบอาชีพ กิจกรรมเพื่อความบันเทิง และการออกกำลังกาย) โดยรวมเป็นเวลาเท่าใดใน 1 สัปดาห์ ",
        "answer": exercise
      },
      "evaluate_q3_4": {
        "question": "4) ใน 1 สัปดาห์ที่ผ่านมา ท่านนั่งหรือเอนกายติดต่อกันนาน 2 ชม.ขึ้นไป โดยไม่รวมการนอนหลับ คิดเป็นกี่วันใน 1 สัปดาห์ ",
        "answer": lollop
      },
      "evaluate_q3_5": {
        "question": "3) ใน 1 สัปดาห์ ท่านกินอาหารกลุ่มผักวันละ 5 ทัพพี (1 ทัพพีเท่ากับ 3 ช้อนกินข้าว) บ่อยครั้งเพียงใด",
        "answer": vegetable
      },
      "evaluate_q3_6": [
        {
          "question_group": "การบริโภคหวาน",
          "question": "ดื่มน้ำเปล่า กาแฟดำ ชาไม่ใส่น้ำตาล โซดา",
          "score": eating['eating1']
        },
        {
          "question_group": "การบริโภคหวาน",
          "question": "ดื่มน้ำอัดลม กาแฟ 3in1 กาแฟเย็น กาแฟปั่น เครื่องดื่มชง น้ำหวาน นมเปรี้ยว",
          "score": eating['eating2']
        },
        {
          "question_group": "การบริโภคหวาน",
          "question": "ดื่มน้ำผักผลไม้สำเร็จรูป",
          "score": eating['eating3']
        },
        {
          "question_group": "การบริโภคหวาน",
          "question": "กินไอศกรีม เบเกอรี่หรือขนมหวานไทย",
          "score": eating['eating4']
        },
        {
          "question_group": "การบริโภคหวาน",
          "question": "เติมน้ำตาล น้ำผึ้ง น้ำเชื่อม เพิ่มลงในอาหาร",
          "score": eating['eating5']
        },
        {
          "question_group": "การบริโภคมัน",
          "question": "เลือกกินเนื้อสัตว์ติดมัน ติดหนัง ไขมันแทรก",
          "score": eating['eating6']
        },
        {
          "question_group": "การบริโภคมัน",
          "question": "กินอาหารทอด อาหารฟาสฟู้ด อาหารผัดน้ำมัน",
          "score": eating['eating7']
        },
        {
          "question_group": "การบริโภคมัน",
          "question": "กินอาหารจานเดียว ไขมันสูง หรืออาหารประเภทแกงกะทิ",
          "score": eating['eating8']
        },
        {
          "question_group": "การบริโภคมัน",
          "question": "ดื่มเครื่องดื่มที่ชง ผสมนมข้นหวาน ครีมเทียม วิปปังครีม",
          "score": eating['eating9']
        },
        {
          "question_group": "การบริโภคมัน",
          "question": "ซดน้ำผัด/น้ำแกงหรือราดน้ำผัด/น้ำแกงลงในข้าว",
          "score": eating['eating10']
        },
        {
          "question_group": "การบริโภคเค็ม",
          "question": "ชิมอาหารก่อนปรุง น้ำปลา ซีอิ้ว ซอส ปรุงน้อย หรือไม่ปรุงเพิ่ม",
          "score": eating['eating11']
        },
        {
          "question_group": "การบริโภคเค็ม",
          "question": "กินอาหารที่มีสมุนไพร หรือเครื่องเทศเป็นส่วนประกอบอาหารแทนเครื่องปรุง",
          "score": eating['eating12']
        },
        {
          "question_group": "การบริโภคเค็ม",
          "question": "กินเนื้อสัตว์แปรรูป ไส้กรอก หมูยอ แฮม ปลาเค็ม กุ้งแห้ง ปลาร้า",
          "score": eating['eating13']
        },
        {
          "question_group": "การบริโภคเค็ม",
          "question": "กินบะหมี่ โจ๊กกึ่งสำเร็จรูป หรืออาหารกล่องแช่แข็ง",
          "score": eating['eating14']
        },
        {
          "question_group": "การบริโภคเค็ม",
          "question": "กินผักผลไม้ดองหรือผลไม้แช่อิ่ม จิ้มพริกเกลือ น้ำปลาหวาน",
          "score": eating['eating15']
        }
      ]
    }
    console.log(inform)

    healthBehaviorSurvey(inform)

  }

  const healthBehaviorSurvey = async (data) => {
    setLoading(true)
    let res = await api.HealthBehaviorSurvey(data)
    setLoading(false)
    if (res) {
      if (res['data']['code'] == 200) {
        // console.log(res['data'])
        navigate('/healthBehaviorSurveyResults', { state: { information: res['data']['data'], height: data['height'], weight: data['weight'] } })
      } else {
        //alert(res['data']['message'])
      }
    } else {
      alert('ไม่ตอบสนอง')
    }
  }

  const convertDate = (dataDate) => {
    const date = new Date(dataDate)
    const optionDate = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }
    const thaiLocale = 'th-TH';
    const formattedDate = date.toLocaleDateString(thaiLocale, optionDate)

    const newDate = `${formattedDate}`
    return newDate
  }

  return (
    <>
        {/* Cancel Modal */}
        {showCancelModal && (
            <CustomizedModal
            onClose={handleCloseCancelModal}
            apiCall={confirmCancelChanges}
            confirmMessage="ยกเลิกการเปลี่ยนแปลง?"
            confirmButtonText="ตกลง"
            />
        )}
      {openCalendar &&
        <ModalCalendar
          onClose={() => { setOpenCalendar(false) }}
          onSubmit={() => { setOpenCalendar(false) }}
          value={
            data['birthday'] ? dayjs(moment(data['birthday']['$d']).format('YYYY-MM-DD')) : dayjs(moment(new Date()).format('YYYY-MM-DD'))
          }
          setValue={(e) => {
            setData({ ...data, birthday: e });
          }}
          disableDay={disabledDay}
        />
      }

      <Loader loading={loading} />
      <Box sx={{ display: 'grid', gridGap: '10px' }}>
      {/* Back Button */}
        <Box className={`${styles.bodyText} ${styles.inlineFlex}`} onClick={() => { setShowCancelModal(true) }}>
          <img src={back} alt="Previous" className={styles.directIcon} />
          กลับไป แบบประเมินสุขภาพ
      </Box>

        <Box
          sx={{
            fontWeight: 600,
            color: "#478F96",
            "@media (max-width: 800px)": {
              textAlign: "center",
            },
          }}
        >
          แบบสำรวจพฤติกรรมสุขภาพกำลังพล สป. ปี พศ. 2568
        </Box>

        <React.Fragment>
          {location.state.button === "1" ? (
            <></>
          ) : null}
          {location.state.button === "2" ? (
            <Box sx={{ display: "flex", margin: "10px 0" }}>
              {/* Back Button */}
              <Box className={`${styles.bodyText} ${styles.inlineFlex}`} onClick={() => { handleButton("1") }}>
                    <img src={back} alt="Previous" className={styles.directIcon} />
                    ย้อนกลับ
              </Box>
            </Box>
          ) : null}
          {location.state.button === "3" ? (
            <Box sx={{ display: "flex", margin: "10px 0" }}>
              {/* Back Button */}
              <Box className={`${styles.bodyText} ${styles.inlineFlex}`} onClick={() => { handleButton("2") }}>
                    <img src={back} alt="Previous" className={styles.directIcon} />
                    ย้อนกลับ
              </Box>
            </Box>
          ) : null}
        </React.Fragment>

        <Box sx={{ display: "flex", justifyContent: "center", margin: "10px 0" }}>
          {location.state.button === "1" ? (
            <img className={styles.number} src={one} />
          ) : null}
          {location.state.button === "2" ? (
            <img className={styles.number} src={two} />
          ) : null}
          {location.state.button === "3" ? (
            <img className={styles.number} src={three} />
          ) : null}
        </Box>

        <Box>
          {location.state.button === "1" ? (
            <Box
              sx={{
                display: "grid",
                gridGap: "20px",
                marginTop: "20px",
              }}
            >
              <Box
                sx={{
                  fontWeight: 600,
                  "@media (max-width: 800px)": {
                    fontSize: "14px",
                  },
                }}
              >
                ส่วนที่ 1 : ข้อมูลทั่วไป
              </Box>

              <Box
                sx={{
                  border: "1px solid #AEB4DD",
                  borderRadius: "5px",
                  padding: "20px",
                }}
              >
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gridGap: "20px",
                    "@media (max-width: 800px)": {
                      gridTemplateColumns: "1fr",
                    },
                  }}
                >
                  <Box>
                    <Typography>ยศ</Typography>
                    <Autocomplete
                      fullWidth
                      size='small'
                      options={titlename}
                      value={data["title_name"]}
                      onChange={(e, value) => {
                        setData({ ...data, 'title_name': value?.['label'] });
                      }}
                      renderInput={(params) =>
                        <TextField {...params}
                          placeholder="เลือกยศ"
                        />
                      }
                    />
                  </Box>

                  <Box>
                    <Typography>สังกัด</Typography>
                    <Autocomplete
                      fullWidth
                      size='small'
                      options={department}
                      value={data["department_name"]}
                      onChange={(e, value) => {
                        setData({ ...data, 'department_name': value?.['label'], 'department_code': value?.['key'] });
                      }}
                      renderInput={(params) =>
                        <TextField {...params}
                          placeholder="เลือกสังกัด"
                        />
                      }
                    />
                  </Box>

                  <Box>
                    <Typography>เพศ</Typography>
                    <Select
                      size="small"
                      fullWidth
                      value={data["sex"] || "null"}
                      name={"sex"}
                      onChange={handleChange}
                    >
                      <MenuItem value="null" disabled>
                        เลือกเพศ
                      </MenuItem>
                      {gender.map((i, idx) => (
                        <MenuItem key={idx} value={i['value']}>{i['name']}</MenuItem>
                      ))}
                    </Select>
                  </Box>

                  <Box>
                    <Typography>เลขบัตรประชาชน</Typography>
                    <TextField
                      type="number"
                      placeholder="กรอกเลขบัตรประชาชน 13 หลัก"
                      size="small"
                      fullWidth
                      value={data["pid"]}
                      name={"pid"}
                      onChange={handleChangePID}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: isValidpid ? '' : 'red',
                          }
                        },
                      }}
                    />
                  </Box>

                  <Box>
                    <Typography>ชื่อ</Typography>
                    <TextField
                      placeholder="ชื่อ"
                      size="small"
                      fullWidth
                      value={data["fname"]}
                      name={"fname"}
                      onChange={handleChange}
                    />
                  </Box>

                  <Box>
                    <Typography>นามสกุล</Typography>
                    <TextField
                      placeholder="นามสกุล"
                      size="small"
                      fullWidth
                      value={data["lname"]}
                      name={"lname"}
                      onChange={handleChange}
                    />
                  </Box>

                  <Box>
                    <Typography>วันเดือนปีเกิด</Typography>
                    <TextField
                      fullWidth
                      size='small'
                      value={data['birthday'] === '' ? 'เลือกวันเกิด' : convertDate(data['birthday'])}
                      InputProps={{
                        inputProps: {
                          readOnly: true,
                        },
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => { setOpenCalendar(true) }}
                            >
                              <CalendarTodayIcon />
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    />
                  </Box>

                  <Box>
                    <Typography>อายุ</Typography>
                    <TextField
                      type="number"
                      placeholder="อายุ"
                      size="small"
                      fullWidth
                      value={data["age"]}
                      name={"age"}
                      onChange={handleChangeAge}
                    />
                  </Box>

                  <Box>
                    <Typography>หมายเลขโทรศัพท์</Typography>
                    <TextField
                      type="number"
                      placeholder="กรอกเบอร์โทรศัพท์"
                      size="small"
                      fullWidth
                      value={data["phone"]}
                      name={"phone"}
                      onChange={handleChangePhone}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: isValidphone ? '' : 'red',
                          }
                        },
                      }}
                    />
                  </Box>

                </Box>
              </Box>

              <Box
                sx={{
                  border: "1px solid #AEB4DD",
                  borderRadius: "5px",
                  padding: "20px",
                }}
              >
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gridGap: "20px",
                    "@media (max-width: 800px)": {
                      gridTemplateColumns: "1fr",
                    },
                  }}
                >
                  <Box>
                    <Typography>น้ำหนัก (กก.)</Typography>
                    <TextField
                      type="number"
                      placeholder="กรอกน้ำหนัก (ตัวเลขเท่านั้น)"
                      size="small"
                      fullWidth
                      value={data["weight"]}
                      name={"weight"}
                      onChange={(e) => {
                        const value = e.target.value;
                        setData({ ...data, 'weight': value });

                        const regex = /\b(1[0-4][0-9]|150|[3-9][5-9]|[4-9][0-9])\b/;
                        setIsValidweight(regex.test(value));
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: isValidweight ? '' : 'red',
                          }
                        },
                      }}
                    />
                  </Box>
                  <Box>
                    <Typography>ส่วนสูง (ซม.)</Typography>
                    <TextField
                      type="number"
                      placeholder="กรอกส่วนสูง (ตัวเลขเท่านั้น)"
                      size="small"
                      fullWidth
                      value={data['height']}
                      name={"height"}
                      onChange={(e) => {
                        const value = e.target.value;
                        setData({ ...data, 'height': value });

                        const regex = /\b(1[4-9][0-9]|20[0-9]|210|220)\b/;
                        setIsValidheight(regex.test(value));
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: isValidheight ? '' : 'red',
                          }
                        },
                      }}
                    />
                  </Box>
                  <Box>
                    <Typography>รอบเอว (ซม.)</Typography>
                    <TextField
                      type="number"
                      placeholder="กรอกรอบเอว (ระหว่าง 50-150)"
                      size="small"
                      fullWidth
                      value={data['waist']}
                      name={"waist"}
                      onChange={(e) => {
                        const value = e.target.value;
                        setData({ ...data, 'waist': value });

                        const regex = /\b(150|1[0-4][0-9]|[5-9][0-9])\b/;
                        setIsValidwaist(regex.test(value));
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: isValidwaist ? '' : 'red',
                          }
                        },
                      }}
                    />
                  </Box>
                </Box>
              </Box>

              <Box
                sx={{
                  fontWeight: 600,
                  "@media (max-width: 800px)": {
                    fontSize: "14px",
                  },
                }}
              >
                การยินยอม
              </Box>

              <Box
                sx={{
                  border: "1px solid #AEB4DD",
                  borderRadius: "5px",
                  padding: "20px",
                }}
              >
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr",
                    gridGap: "10px"
                  }}
                >
                  <Typography sx={{ textIndent: '2rem' }}>ข้าพเจ้ายินยอมให้ สนพ.สสน.สป. และโรงพยาบาลที่ตรวจสุขภาพประจำปี สามารถนำผลการประเมินพฤติกรรม และผลการตรวจสุขภาพประจำปี มาใช้ในการติดตามภาวะสุขภาพ ดูแล ป้องกัน รักษาและสร้างเสริมสุขภาพ เพื่อเป็นประโยชน์ต่อตัวของข้าพเจ้าเอง และประโยชน์ในการปฏิบัติงานแก่ สนพ.สสน.สป.</Typography>
                  <Typography sx={{ textIndent: '2rem' }}>โดยทาง สนพ.สสน.สป. จะขอความยินยอมจากท่าน ดังนี้</Typography>
                  <Typography sx={{ textIndent: '2rem' }}>1. ใช้ข้อมูลส่วนบุคคล ได้แก่ ยศ ชื่อ นามสกุล เบอร์โทรศัพท์ เพื่อใช้ในการติดตาม หากท่านมีผลตรวจที่อยู่ในเกณฑ์ผิดปกติหรือพบแพทย์ด่วน</Typography>
                  <Typography sx={{ textIndent: '2rem' }}>2. ใช้ข้อมูลเลขบัตรประชาชนของท่าน เพื่อให้ในการเชื่อมโยงข้อมูลการตรวจสุขภาพ การทำแบบประเมิน</Typography>
                  <Typography sx={{ textIndent: '2rem' }}>3. ใช้ข้อมูลผลตรวจสุขภาพประจำปี ผลการประเมินพฤติกรรมสุขภาพและสุขภาพจิตของท่าน เพื่อใช้ในการวิเคราะห์ข้อมูล ติดตามภาวะสุขภาพ จัดกิจกรรมสร้างเสริมสุขภาพ</Typography>

                  <FormControl>
                    <RadioGroup
                      value={data['consent']}
                      onChange={(e) => { setData({ ...data, 'consent': e.target.value }) }}
                    >
                      <FormControlLabel value={'Y'} control={<Radio />} label="ข้าพเจ้ายินยอม ตามข้อความข้างต้น" />
                      <FormControlLabel value={'N'} control={<Radio />} label="ข้าพเจ้าไม่ยินยอม ให้ สนพ.สสน.สป. นำข้อมูลไปใช้ และไม่ต้องการได้รับการติดตามภาวะสุขภาพใด ๆ" />
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Box>

              <Box
                sx={{
                  textAlign: "center",
                }}
              >
                <Button
                  variant="contained"
                  sx={{
                    width: "150px",
                    "@media (max-width: 800px)": {
                      width: "100px",
                    },
                  }}
                  onClick={() => {
                    if (!data['title_name']) {
                      return alert('กรุณาเลือกยศ')
                    }
                    if (!data['department_name']) {
                      return alert('กรุณาเลือกสังกัด')
                    }
                    if (!data['fname']) {
                      return alert('กรุณากรอกชื่อ')
                    }
                    if (!data['lname']) {
                      return alert('กรุณากรอกนามสกุล')
                    }
                    if (!data['sex']) {
                      return alert('กรุณาเลือกเพศ')
                    }
                    if (!data['age']) {
                      return alert('กรุณากรอกอายุ')
                    }

                    if (!data['birthday']) {
                      return alert('กรุณาเลือกวันเกิด')
                    }

                    if (!data['pid']) {
                      return alert('กรุณากรอกเลขบัตรประชาชน')
                    }
                    if (data['pid']) {
                      const regex = /^\d{13}$/;
                      if (!regex.test(data['pid'])) {
                        return alert('กรุณาตรวจสอบเลขบัตรประชาชน')
                      }
                    }

                    if (!data['phone']) {
                      return alert('กรุณากรอกเบอร์โทรศัพท์')
                    }
                    if (data['phone']) {
                      const regex = /^\d{10}$/;
                      if (!regex.test(data['phone'])) {
                        return alert('กรุณาตรวจสอบเบอร์โทรศัพท์')
                      }
                    }

                    if (data['weight']) {
                      if (Number(data['weight']) >= 35 && Number(data['weight']) <= 150) {

                      } else {
                        return alert('กรุณากรอกน้ำหนักระหว่าง 35-150')
                      }
                    }
                    if (!data['weight']) {
                      return alert('กรุณากรอกน้ำหนัก')
                    }

                    if (data['height']) {
                      if (Number(data['height']) >= 140 && Number(data['height']) <= 220) {

                      } else {
                        return alert('กรุณากรอกส่วนสูงระหว่าง 140-220')
                      }
                    }
                    if (!data['height']) {
                      return alert('กรุณากรอกส่วนสูง')
                    }

                    if (data['waist']) {
                      if (Number(data['waist']) >= 50 && Number(data['waist']) <= 150) {

                      } else {
                        return alert('กรุณากรอกรอบเอวระหว่าง 50-150')
                      }
                    }
                    if (!data['waist']) {
                      return alert('กรุณากรอกรอบเอว')
                    }

                    if (!data['consent']) {
                      return alert('กรุณาเลือกการยินยอม')
                    }
                    handleButton("2");
                  }}
                >
                  เริ่มประเมิน
                </Button>
              </Box>
            </Box>
          ) : null}

          {location.state.button === "2" ? (
            <Box
              sx={{
                display: "grid",
                gridGap: "20px",
                marginTop: "20px",
              }}
            >
              <Box
                sx={{
                  fontWeight: 600,
                  "@media (max-width: 800px)": {
                    fontSize: "14px",
                  },
                }}
              >ส่วนที่ 2 : ข้อมูลสุขภาพ</Box>

              <Box
                sx={{
                  border: "1px solid #AEB4DD",
                  borderRadius: "5px",
                  padding: "20px",
                }}
              >
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr",
                    gridGap: "10px"
                  }}
                >
                  <Box sx={{ display: 'flex', gridGap: '10px', fontWeight: 600 }}><CircleIcon sx={{ width: '5px' }} /> ท่านมีโรคประจำตัวที่ต้องพบแพทย์และรับประทานยาอย่างต่อเนื่องหรือไม่ (เลือกได้หลายตัวเลือก)</Box>
                  <FormControl>
                    <RadioGroup
                      value={disease}
                      onChange={(e) => {
                        if (e.target.value === 'ไม่มีโรคประจำตัว') {
                          setDiseaseList([])
                          setOther(false)
                          setRemark('')
                        }
                        setDisease(e.target.value)
                      }}
                    >
                      <FormControlLabel value={'ไม่มีโรคประจำตัว'} control={<Radio />} label="ไม่มีโรคประจำตัว" />
                      <FormControlLabel value={'มีโรคประจำตัว'} control={<Radio />} label="มีโรคประจำตัว" />
                    </RadioGroup>
                  </FormControl>
                  <Box sx={{ marginLeft: '2rem' }}>
                    {diseaseAll.map((i, idx) => (
                      <Box key={idx}>
                        <FormGroup
                          onChange={() => {
                            if (!diseaseList.includes(i)) {
                              diseaseList.push(i)
                              setDiseaseList([...diseaseList])
                            } else {
                              setDiseaseList(diseaseList.filter(item => item !== i))
                            }
                          }}
                        >
                          <FormControlLabel
                            disabled={disease === 'ไม่มีโรคประจำตัว'}
                            control={
                              <Checkbox
                                checked={diseaseList.includes(i)}
                              />
                            }
                            label={i}
                          />
                        </FormGroup>
                      </Box>
                    ))}
                    <Box sx={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 3fr',
                      "@media (max-width: 800px)": {
                        gridTemplateColumns: '1fr'
                      },
                    }}>
                      <FormControlLabel
                        disabled={disease === 'ไม่มีโรคประจำตัว'}
                        control={
                          <Checkbox
                            value={other}
                            checked={other}
                            onChange={() => { setOther(!other) }}
                          />}
                        label='อื่น ๆ โปรดระบุ' />
                      <TextField
                        size='small'
                        disabled={disease === 'ไม่มีโรคประจำตัว' || !other}
                        value={remark}
                        onChange={(e) => { setRemark(e.target.value) }}
                      />
                    </Box>
                  </Box>
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  gridGap: "20px",
                  "@media (max-width: 800px)": {
                    display: "grid",
                  },
                }}
              >
                <Button
                  variant="contained"
                  sx={{
                    width: "150px",
                    "@media (max-width: 800px)": {
                      width: "100px",
                    },
                  }}
                  onClick={() => {
                    if (!disease) {
                      return alert('กรุณาเลือกข้อมูลสุขภาพ')
                    }
                    // console.log(disease, diseaseList)
                    handleButton("3");
                  }}
                >
                  ถัดไป
                </Button>
              </Box>
            </Box>
          ) : null}

          {location.state.button === "3" ?
            <Box
              sx={{
                display: "grid",
                gridGap: "20px",
                marginTop: "20px",
              }}
            >
              <Box sx={{
                fontWeight: 600,
                "@media (max-width: 800px)": {
                  fontSize: "14px",
                },
              }}>
                ส่วนที่ 3 : ข้อมูลพฤติกรรมสุขภาพ
              </Box>

              <Box
                sx={{
                  border: "1px solid #AEB4DD",
                  borderRadius: "5px",
                  padding: "20px",
                }}
              >
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr",
                    gridGap: "10px"
                  }}
                >
                  <Box>
                    <Typography sx={{ fontWeight: 600 }}>1) ท่านสูบบุหรี่หรือบุหรี่ไฟฟ้าหรือไม่</Typography>
                    <FormControl sx={{ marginLeft: '20px' }}>
                      <RadioGroup
                        value={smoke['smoke']}
                        onChange={(e) => {
                          setSmoke({ ...smoke, smoking: '' });
                          if (e.target.value == 'ไม่สูบ' || e.target.value == 'เคยสูบแต่เลิกแล้ว') {
                            setQuitSmoking(false)
                            setSmoke({ ...smoke, smoke: e.target.value, smoking: '', need: '' });
                          } else {
                            setQuitSmoking(true)
                            setSmoke({ ...smoke, smoke: e.target.value });
                          }
                        }}
                      >
                        <FormControlLabel value='ไม่สูบ' control={<Radio />} label="ไม่สูบ" />
                        <FormControlLabel value='เคยสูบแต่เลิกแล้ว' control={<Radio />} label="เคยสูบแต่เลิกแล้ว" />
                        <FormControlLabel value='สูบ' control={<Radio />} label="สูบ" />
                      </RadioGroup>

                      <RadioGroup
                        sx={{ marginLeft: '20px' }}
                        value={smoke['smoking']}
                        onChange={(e) => {
                          setSmoke({ ...smoke, smoking: e.target.value });
                        }}
                      >
                        <FormControlLabel disabled={smoke['smoke'] !== "สูบ"} value='บุหรี่มวน' control={<Radio />} label="บุหรี่มวน" />
                        <FormControlLabel disabled={smoke['smoke'] !== "สูบ"} value='บุหรี่ไฟฟ้า' control={<Radio />} label="บุหรี่ไฟฟ้า" />
                        <FormControlLabel disabled={smoke['smoke'] !== "สูบ"} value='สูบทั้งสองชนิด' control={<Radio />} label="สูบทั้งสองชนิด" />
                      </RadioGroup>

                      {quitSmoking &&
                        <>
                          <Typography sx={{ fontWeight: 600 }}>1.1) ท่านต้องการเลิกบุหรี่หรือไม่</Typography>
                          <RadioGroup
                            value={smoke['need']}
                            onChange={(e) => {
                              setSmoke({ ...smoke, need: e.target.value });
                            }}
                          >
                            <FormControlLabel value='ต้องการเลิก' control={<Radio />} label="ต้องการเลิก" />
                            <FormControlLabel value='ไม่ต้องการเลิก' control={<Radio />} label="ไม่ต้องการเลิก" />
                          </RadioGroup>
                        </>
                      }

                    </FormControl>
                  </Box>
                  <Box sx={{ borderTop: '1px solid #D9D9D9' }}></Box>

                  <Box>
                    <Typography sx={{ fontWeight: 600 }}>2) ท่านดื่มสุรา หรือเครื่องดื่มที่มีแอลกอฮอล์หรือไม่</Typography>
                    <RadioGroup
                      sx={{ marginLeft: '20px' }}
                      value={alcohol}
                      onChange={(e) => {
                        setAlcohol(e.target.value)
                      }}
                    >
                      <FormControlLabel value='ไม่ดื่ม' control={<Radio />} label="ไม่ดื่ม" />
                      <FormControlLabel value='เคยดื่มแต่เลิกแล้ว' control={<Radio />} label="เคยดื่มแต่เลิกแล้ว" />
                      <FormControlLabel value='ดื่มนาน ๆ ครั้ง' control={<Radio />} label="ดื่มนาน ๆ ครั้ง" />
                      <FormControlLabel value='ดื่มเป็นประจำ' control={<Radio />} label="ดื่มเป็นประจำ" />
                    </RadioGroup>
                  </Box>
                  <Box sx={{ borderTop: '1px solid #D9D9D9' }}></Box>

                  <Box>
                    <Typography sx={{ fontWeight: 600 }}>3) ท่านมีการขยับร่างกายจนเหนื่อยกว่าปกติ (รวมการทำงาน การเดินทาง การประกอบอาชีพ กิจกรรมเพื่อความบันเทิง และการออกกำลังกาย) โดยรวมเป็นเวลาเท่าใดใน 1 สัปดาห์</Typography>
                    <RadioGroup
                      sx={{ marginLeft: '20px' }}
                      value={exercise}
                      onChange={(e) => {
                        setExercise(e.target.value)
                      }}
                    >
                      <FormControlLabel value='ไม่ได้ทำเลย' control={<Radio />} label="ไม่ได้ทำเลย" />
                      <FormControlLabel value='น้อยกว่า 150 นาทีต่อสัปดาห์' control={<Radio />} label="น้อยกว่า 150 นาทีต่อสัปดาห์" />
                      <FormControlLabel value='มากกว่าหรือเท่ากับ 150 นาทีต่อสัปดาห์' control={<Radio />} label="มากกว่าหรือเท่ากับ 150 นาทีต่อสัปดาห์" />
                    </RadioGroup>
                  </Box>
                  <Box sx={{ borderTop: '1px solid #D9D9D9' }}></Box>

                  <Box>
                    <Typography sx={{ fontWeight: 600 }}>4) ใน 1 สัปดาห์ที่ผ่านมา ท่านนั่งหรือเอนกายติดต่อกันนาน 2 ชม.ขึ้นไป โดยไม่รวมการนอนหลับ คิดเป็นกี่วันใน 1 สัปดาห์</Typography>
                    <RadioGroup
                      sx={{ marginLeft: '20px' }}
                      value={lollop}
                      onChange={(e) => {
                        setLollop(e.target.value)
                      }}
                    >
                      <FormControlLabel value='ประมาณ 6-7 วันต่อสัปดาห์' control={<Radio />} label="ประมาณ 6-7 วันต่อสัปดาห์" />
                      <FormControlLabel value='ประมาณ 3-5 วันต่อสัปดาห์' control={<Radio />} label="ประมาณ 3-5 วันต่อสัปดาห์" />
                      <FormControlLabel value='ประมาณ 0-2 วันต่อสัปดาห์' control={<Radio />} label="ประมาณ 0-2 วันต่อสัปดาห์" />
                    </RadioGroup>
                  </Box>
                  <Box sx={{ borderTop: '1px solid #D9D9D9' }}></Box>

                  <Box>
                    <Typography sx={{ fontWeight: 600 }}>5) ใน 1 สัปดาห์ ท่านกินอาหารกลุ่มผักวันละ 5 ทัพพี (1 ทัพพีเท่ากับ 3 ช้อนกินข้าว) บ่อยครั้งเพียงใด</Typography>
                    <RadioGroup
                      sx={{ marginLeft: '20px' }}
                      value={vegetable}
                      onChange={(e) => {
                        setVegetable(e.target.value)
                      }}
                    >
                      <FormControlLabel value='กินทุกวัน' control={<Radio />} label="กินทุกวัน" />
                      <FormControlLabel value='ประมาณ 4-6 วันต่อสัปดาห์' control={<Radio />} label="ประมาณ 4-6 วันต่อสัปดาห์" />
                      <FormControlLabel value='ประมาณ 1-3 วันต่อสัปดาห์' control={<Radio />} label="ประมาณ 1-3 วันต่อสัปดาห์" />
                      <FormControlLabel value='ไม่กินเลย' control={<Radio />} label="ไม่กินเลย" />
                    </RadioGroup>
                  </Box>
                  <Box sx={{ borderTop: '1px solid #D9D9D9' }}></Box>

                  <Box>
                    <Typography sx={{ fontWeight: 600 }}>6) พฤติกรรมการรับประทานอาหาร</Typography>
                    <Box sx={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr',
                      "@media (max-width: 800px)": {
                        gridTemplateColumns: '1fr'
                      },
                    }}>
                      <Box></Box>
                      <Box sx={{
                        fontWeight: 600,
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr 1fr',
                        textAlign: 'center',
                        color: '#478F96',
                        "@media (max-width: 800px)": {
                          padding: '10px 0',
                          fontSize: "14px",
                        },
                      }}>
                        <Box>ทุกวัน/ เกือบทุกวัน</Box>
                        <Box>3-4 ครั้ง/ สัปดาห์</Box>
                        <Box>แทบไม่ทำ/ ไม่ทำเลย</Box>
                      </Box>
                    </Box>
                    <Box sx={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr',
                      alignItems: 'center',
                      "@media (max-width: 800px)": {
                        gridTemplateColumns: '1fr',
                        textAlign: 'center',
                        fontSize: '12px'
                      },
                    }}>
                      <Box sx={{ display: 'flex', gridGap: '10px' }}>
                        <CircleIcon sx={{ width: '5px' }} />
                        ดื่มน้ำเปล่า กาแฟดำ ชาไม่ใส่น้ำตาล โซดา
                      </Box>
                      <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr 1fr',
                        textAlign: 'center'
                      }}>
                        {option.map((item, index) => (
                          <GreenRadio
                            key={index}
                            checked={eating['eating1'] === item}
                            onChange={() => { setEating({ ...eating, eating1: item }) }}
                            value={eating['eating1']}
                            name={'eating1'}
                          />
                        ))}
                      </Box>
                    </Box>
                    <Box sx={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr',
                      alignItems: 'center',
                      "@media (max-width: 800px)": {
                        gridTemplateColumns: '1fr',
                        textAlign: 'center',
                        fontSize: '12px'
                      },
                    }}>
                      <Box sx={{ display: 'flex', gridGap: '10px' }}>
                        <CircleIcon sx={{ width: '5px' }} />
                        ดื่มน้ำอัดลม กาแฟ 3in1 กาแฟเย็น กาแฟปั่น เครื่องดื่มชง น้ำหวาน นมเปรี้ยว
                      </Box>
                      <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr 1fr',
                        textAlign: 'center'
                      }}>
                        {option1.map((item, index) => (
                          <GreenRadio
                            key={index}
                            checked={eating['eating2'] === item}
                            onChange={() => { setEating({ ...eating, eating2: item }) }}
                            value={eating['eating2']}
                            name={'eating2'}
                          />
                        ))}
                      </Box>
                    </Box>
                    <Box sx={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr',
                      alignItems: 'center',
                      "@media (max-width: 800px)": {
                        gridTemplateColumns: '1fr',
                        textAlign: 'center',
                        fontSize: '12px'
                      },
                    }}>
                      <Box sx={{ display: 'flex', gridGap: '10px' }}>
                        <CircleIcon sx={{ width: '5px' }} />
                        ดื่มน้ำผักผลไม้สำเร็จรูป
                      </Box>
                      <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr 1fr',
                        textAlign: 'center'
                      }}>
                        {option1.map((item, index) => (
                          <GreenRadio
                            key={index}
                            checked={eating['eating3'] === item}
                            onChange={() => { setEating({ ...eating, eating3: item }) }}
                            value={eating['eating3']}
                            name={'eating3'}
                          />
                        ))}
                      </Box>
                    </Box>
                    <Box sx={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr',
                      alignItems: 'center',
                      "@media (max-width: 800px)": {
                        gridTemplateColumns: '1fr',
                        textAlign: 'center',
                        fontSize: '12px'
                      },
                    }}>
                      <Box sx={{ display: 'flex', gridGap: '10px' }}>
                        <CircleIcon sx={{ width: '5px' }} />
                        กินไอศกรีม เบเกอรี่หรือขนมหวานไทย
                      </Box>
                      <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr 1fr',
                        textAlign: 'center'
                      }}>
                        {option1.map((item, index) => (
                          <GreenRadio
                            key={index}
                            checked={eating['eating4'] === item}
                            onChange={() => { setEating({ ...eating, eating4: item }) }}
                            value={eating['eating4']}
                            name={'eating4'}
                          />
                        ))}
                      </Box>
                    </Box>
                    <Box sx={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr',
                      alignItems: 'center',
                      "@media (max-width: 800px)": {
                        gridTemplateColumns: '1fr',
                        textAlign: 'center',
                        fontSize: '12px'
                      },
                    }}>
                      <Box sx={{ display: 'flex', gridGap: '10px' }}>
                        <CircleIcon sx={{ width: '5px' }} />
                        เติมน้ำตาล น้ำผึ้ง น้ำเชื่อม เพิ่มลงในอาหาร
                      </Box>
                      <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr 1fr',
                        textAlign: 'center'
                      }}>
                        {option1.map((item, index) => (
                          <GreenRadio
                            key={index}
                            checked={eating['eating5'] === item}
                            onChange={() => { setEating({ ...eating, eating5: item }) }}
                            value={eating['eating5']}
                            name={'eating5'}
                          />
                        ))}
                      </Box>
                    </Box>
                    <Box sx={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr',
                      alignItems: 'center',
                      "@media (max-width: 800px)": {
                        gridTemplateColumns: '1fr',
                        textAlign: 'center',
                        fontSize: '12px'
                      },
                    }}>
                      <Box sx={{ display: 'flex', gridGap: '10px' }}>
                        <CircleIcon sx={{ width: '5px' }} />
                        เลือกกินเนื้อสัตว์ ติดมัน ติดหนัง
                      </Box>
                      <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr 1fr',
                        textAlign: 'center'
                      }}>
                        {option1.map((item, index) => (
                          <GreenRadio
                            key={index}
                            checked={eating['eating6'] === item}
                            onChange={() => { setEating({ ...eating, eating6: item }) }}
                            value={eating['eating6']}
                            name={'eating6'}
                          />
                        ))}
                      </Box>
                    </Box>
                    <Box sx={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr',
                      alignItems: 'center',
                      "@media (max-width: 800px)": {
                        gridTemplateColumns: '1fr',
                        textAlign: 'center',
                        fontSize: '12px'
                      },
                    }}>
                      <Box sx={{ display: 'flex', gridGap: '10px' }}>
                        <CircleIcon sx={{ width: '5px' }} />
                        กินอาหารทอด อาหารฟาสฟู้ด อาหารผัดน้ำมัน
                      </Box>
                      <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr 1fr',
                        textAlign: 'center'
                      }}>
                        {option1.map((item, index) => (
                          <GreenRadio
                            key={index}
                            checked={eating['eating7'] === item}
                            onChange={() => { setEating({ ...eating, eating7: item }) }}
                            value={eating['eating7']}
                            name={'eating7'}
                          />
                        ))}
                      </Box>
                    </Box>
                    <Box sx={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr',
                      alignItems: 'center',
                      "@media (max-width: 800px)": {
                        gridTemplateColumns: '1fr',
                        textAlign: 'center',
                        fontSize: '12px'
                      },
                    }}>
                      <Box sx={{ display: 'flex', gridGap: '10px' }}>
                        <CircleIcon sx={{ width: '5px' }} />
                        กินอาหารจานเดียว ไขมันสูง หรืออาหารประเภทแกงกะทิ
                      </Box>
                      <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr 1fr',
                        textAlign: 'center'
                      }}>
                        {option1.map((item, index) => (
                          <GreenRadio
                            key={index}
                            checked={eating['eating8'] === item}
                            onChange={() => { setEating({ ...eating, eating8: item }) }}
                            value={eating['eating8']}
                            name={'eating8'}
                          />
                        ))}
                      </Box>
                    </Box>
                    <Box sx={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr',
                      alignItems: 'center',
                      "@media (max-width: 800px)": {
                        gridTemplateColumns: '1fr',
                        textAlign: 'center',
                        fontSize: '12px'
                      },
                    }}>
                      <Box sx={{ display: 'flex', gridGap: '10px' }}>
                        <CircleIcon sx={{ width: '5px' }} />
                        ดื่มเครื่องดื่มที่ชง ผสมนมข้นหวาน ครีมเทียม วิปปิ้งครีม
                      </Box>
                      <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr 1fr',
                        textAlign: 'center'
                      }}>
                        {option1.map((item, index) => (
                          <GreenRadio
                            key={index}
                            checked={eating['eating9'] === item}
                            onChange={() => { setEating({ ...eating, eating9: item }) }}
                            value={eating['eating9']}
                            name={'eating9'}
                          />
                        ))}
                      </Box>
                    </Box>
                    <Box sx={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr',
                      alignItems: 'center',
                      "@media (max-width: 800px)": {
                        gridTemplateColumns: '1fr',
                        textAlign: 'center',
                        fontSize: '12px'
                      },
                    }}>
                      <Box sx={{ display: 'flex', gridGap: '10px' }}>
                        <CircleIcon sx={{ width: '5px' }} />
                        ซด น้ำผัด/น้ำแกง หรือ ราดน้ำผัด/น้ำแกง ลงในข้าว
                      </Box>
                      <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr 1fr',
                        textAlign: 'center'
                      }}>
                        {option1.map((item, index) => (
                          <GreenRadio
                            key={index}
                            checked={eating['eating10'] === item}
                            onChange={() => { setEating({ ...eating, eating10: item }) }}
                            value={eating['eating10']}
                            name={'eating10'}
                          />
                        ))}
                      </Box>
                    </Box>
                    <Box sx={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr',
                      alignItems: 'center',
                      "@media (max-width: 800px)": {
                        gridTemplateColumns: '1fr',
                        textAlign: 'center',
                        fontSize: '12px'
                      },
                    }}>
                      <Box sx={{ display: 'flex', gridGap: '10px' }}>
                        <CircleIcon sx={{ width: '5px' }} />
                        ชิมอาหารก่อนปรุง น้ำปลา ซีอิ้ว ซอส ปรุงน้อย หรือไม่ปรุงเลย
                      </Box>
                      <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr 1fr',
                        textAlign: 'center'
                      }}>
                        {option.map((item, index) => (
                          <GreenRadio
                            key={index}
                            checked={eating['eating11'] === item}
                            onChange={() => { setEating({ ...eating, eating11: item }) }}
                            value={eating['eating11']}
                            name={'eating11'}
                          />
                        ))}
                      </Box>
                    </Box>
                    <Box sx={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr',
                      alignItems: 'center',
                      "@media (max-width: 800px)": {
                        gridTemplateColumns: '1fr',
                        textAlign: 'center',
                        fontSize: '12px'
                      },
                    }}>
                      <Box sx={{ display: 'flex', gridGap: '10px' }}>
                        <CircleIcon sx={{ width: '5px' }} />
                        กินอาหารที่มีสมุนไพร หรือเครื่องเทศเป็นส่วนประกอบอาหารแทนเครื่องปรุง
                      </Box>
                      <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr 1fr',
                        textAlign: 'center'
                      }}>
                        {option.map((item, index) => (
                          <GreenRadio
                            key={index}
                            checked={eating['eating12'] === item}
                            onChange={() => { setEating({ ...eating, eating12: item }) }}
                            value={eating['eating12']}
                            name={'eating12'}
                          />
                        ))}
                      </Box>
                    </Box>
                    <Box sx={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr',
                      alignItems: 'center',
                      "@media (max-width: 800px)": {
                        gridTemplateColumns: '1fr',
                        textAlign: 'center',
                        fontSize: '12px'
                      },
                    }}>
                      <Box sx={{ display: 'flex', gridGap: '10px' }}>
                        <CircleIcon sx={{ width: '5px' }} />
                        กินเนื้อสัตว์แปรรูป ไส้กรอก หมูยอ แฮม ปลาเค็ม กุ้งแห้ง ปลาร้า
                      </Box>
                      <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr 1fr',
                        textAlign: 'center'
                      }}>
                        {option1.map((item, index) => (
                          <GreenRadio
                            key={index}
                            checked={eating['eating13'] === item}
                            onChange={() => { setEating({ ...eating, eating13: item }) }}
                            value={eating['eating13']}
                            name={'eating13'}
                          />
                        ))}
                      </Box>
                    </Box>
                    <Box sx={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr',
                      alignItems: 'center',
                      "@media (max-width: 800px)": {
                        gridTemplateColumns: '1fr',
                        textAlign: 'center',
                        fontSize: '12px'
                      },
                    }}>
                      <Box sx={{ display: 'flex', gridGap: '10px' }}>
                        <CircleIcon sx={{ width: '5px' }} />
                        กินบะหมี่ โจ๊กกึ่งสำเร็จรูป หรืออาหารกล่องแช่แข็ง
                      </Box>
                      <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr 1fr',
                        textAlign: 'center'
                      }}>
                        {option1.map((item, index) => (
                          <GreenRadio
                            key={index}
                            checked={eating['eating14'] === item}
                            onChange={() => { setEating({ ...eating, eating14: item }) }}
                            value={eating['eating14']}
                            name={'eating14'}
                          />
                        ))}
                      </Box>
                    </Box>
                    <Box sx={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr',
                      alignItems: 'center',
                      "@media (max-width: 800px)": {
                        gridTemplateColumns: '1fr',
                        textAlign: 'center',
                        fontSize: '12px'
                      },
                    }}>
                      <Box sx={{ display: 'flex', gridGap: '10px' }}>
                        <CircleIcon sx={{ width: '5px' }} />
                        กินผักผลไม้ดองหรือผลไม้แช่อิ่ม จิ้มพริกเกลือหรือน้ำปลาหวาน
                      </Box>
                      <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr 1fr',
                        textAlign: 'center'
                      }}>
                        {option1.map((item, index) => (
                          <GreenRadio
                            key={index}
                            checked={eating['eating15'] === item}
                            onChange={() => { setEating({ ...eating, eating15: item }) }}
                            value={eating['eating15']}
                            name={'eating15'}
                          />
                        ))}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center"
                }}
              >
                <Button
                  variant="contained"
                  sx={{
                    width: "150px",
                    "@media (max-width: 800px)": {
                      width: "100px",
                    },
                  }}
                  onClick={() => {
                    if (!smoke['smoke']) {
                      return alert('กรุณาทำข้อมูลพฤติกรรมสุขภาพข้อที่ 1 ให้ครบถ้วน')
                    }
                    if (smoke['smoke'] === 'สูบ') {
                      if (!smoke['smoking']) {
                        return alert('กรุณาทำข้อมูลพฤติกรรมสุขภาพข้อที่ 1 ให้ครบ')
                      }
                      if (!smoke['need']) {
                        return alert('กรุณาทำข้อมูลพฤติกรรมสุขภาพข้อที่ 1.1')
                      }
                    }
                    if (!alcohol) {
                      return alert('กรุณาทำข้อมูลพฤติกรรมสุขภาพข้อที่ 2')
                    }
                    if (!exercise) {
                      return alert('กรุณาทำข้อมูลพฤติกรรมสุขภาพข้อที่ 3')
                    }
                    if (!lollop) {
                      return alert('กรุณาทำข้อมูลพฤติกรรมสุขภาพข้อที่ 4')
                    }
                    if (!vegetable) {
                      return alert('กรุณาทำข้อมูลพฤติกรรมสุขภาพข้อที่ 5')
                    }
                    if (!eating['eating1'] || !eating['eating2'] || !eating['eating3'] || !eating['eating4'] || !eating['eating5'] || !eating['eating6'] || !eating['eating7'] || !eating['eating8'] || !eating['eating9'] || !eating['eating10'] || !eating['eating11'] || !eating['eating12'] || !eating['eating13'] || !eating['eating14'] || !eating['eating15']) {
                      return alert('กรุณาทำข้อมูลพฤติกรรมสุขภาพข้อที่ 6 ให้ครบถ้วน')
                    }
                    saveHealthBehavior()
                  }}
                >
                  บันทึก
                </Button>
              </Box>
            </Box>
            : null}
        </Box>
      </Box>
    </>
  )
}

const StyledMobileDatePicker = styled(MobileDatePicker)({
  "& .MuiInputBase-input": {
    padding: '8.5px 14px'
  }
});

const design = {
  "& .MuiInputBase-input": {
    border: 'res'
  }
}

const GreenRadio = withStyles({
  root: {
    color: "#696984",
    "&$checked": {
      color: "#478F96",
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />)
